import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";

interface AverageValueMetrics {
  mrp: number;
  asp: number;
  discount: number;
}
interface AverageValues {
  occasion: Record<string, AverageValueMetrics>;
  colour: Record<string, AverageValueMetrics>;
  articleType: Record<string, AverageValueMetrics>;
  season: Record<string, AverageValueMetrics>;
  brand: Record<string, AverageValueMetrics>;
}

interface GetAverageValuesParams {
  jobId: string;
  date: string;
}

const getAverageValues = async ({
  jobId,
  date,
}: GetAverageValuesParams): Promise<AverageValues> => {
  return apiClient
    .get(ENDPOINTS.GET_INSIGHTS_AVERAGE_VALUES(jobId, date))
    .json<AverageValues>();
};

export const useGetAverageValuesQuery = (
  params: GetAverageValuesParams,
  options?: Omit<UseQueryOptions<AverageValues, Error>, "queryKey" | "queryFn">
) => {
  return useQuery({
    queryKey: ["averageValues", params.jobId, params.date],
    queryFn: () => getAverageValues(params),
    ...options,
  });
};
